export const map = (fn) => (result) => result.map(fn);
export const mapErr = (fn) => (result) => result.mapErr(fn);
export const chain = (next) => (result) => result.chain(next);
export const chainErr = (next) => (result) => result.chainErr(next);
export const unwrap = (result) => result.unwrap();
export const unwrapOr = (fallback) => (result) => result.unwrapOr(fallback);
export const unwrapOrThrow = (result) => result.unwrapOrThrow();
export const unwrapOrElse = (fallback) => (result) => result.unwrapOrElse(fallback);
export const unwrapErr = (result) => result.unwrapErr();
export const unwrapErrOr = (fallback) => (result) => result.unwrapErrOr(fallback);
export const unwrapErrOrElse = (fallback) => (result) => result.unwrapErrOrElse(fallback);
export const unpack = (result) => result.unpack();
export const match = (okMatcher, errMatcher) => (result) => result.match(okMatcher, errMatcher);
export const tap = (fn) => (result) => result.tap(fn);
export const tapErr = (fn) => (result) => result.tapErr(fn);
export const biMap = (okFn, errFn) => (result) => result.biMap(okFn, errFn);
export const biChain = (okFn, errFn) => (result) => result.biChain(okFn, errFn);
export const asTuple = (result) => result.asTuple();
